export default "__VITE_ASSET__CHj6a_zP__"